var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuality(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.075 20.283l-2.521-2.566a1.783 1.783 0 00-1.305-.55c-.504 0-.94.183-1.308.55a1.874 1.874 0 00-.573 1.307c-.016.505.16.94.528 1.305l3.895 3.896c.367.367.795.55 1.284.55s.916-.183 1.283-.55l7.792-7.792c.366-.366.55-.801.55-1.305 0-.504-.184-.94-.55-1.307a1.786 1.786 0 00-1.307-.55c-.505 0-.94.183-1.306.55l-6.462 6.462zM15 37.196h-.459a.91.91 0 01-.412-.092c-4.003-1.253-7.303-3.736-9.9-7.449C1.632 25.942.333 21.84.333 17.35V8.687c0-.763.222-1.45.666-2.062a3.791 3.791 0 011.717-1.33l11-4.124c.428-.153.856-.23 1.284-.23.428 0 .855.077 1.283.23l11 4.125a3.79 3.79 0 011.72 1.329c.443.611.665 1.299.663 2.062v8.663c0 4.492-1.298 8.594-3.896 12.307-2.597 3.713-5.897 6.196-9.9 7.447-.152.061-.442.092-.87.092zm0-3.713c3.177-1.008 5.805-3.025 7.883-6.05C24.961 24.408 26 21.047 26 17.35V8.687L15 4.562 4 8.687v8.663c0 3.697 1.039 7.058 3.116 10.083 2.078 3.025 4.706 5.042 7.884 6.05z",
    fill: "url(#quality_svg__paint0_linear_11804_67499)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "quality_svg__paint0_linear_11804_67499",
    x1: 16.725,
    y1: 69.029,
    x2: 41.858,
    y2: 60.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#218FEE"
  })))));
}

export default SvgQuality;